<template>
    <div class="bg-white rounded-2xl shadow-sm border p-8 space-y-8">

        <!-- HEADER -->
        <div>
            <h2 class="text-xl font-bold text-gray-900">Gestion de licence</h2>
            <p class="text-sm text-gray-500 mt-1">
                Prolongez ou bloquez l'accès à la plateforme.
            </p>
        </div>

        <!-- DATE ACTUELLE -->
        <div class="bg-slate-50 border rounded-xl p-6">
            <div class="text-xs uppercase text-gray-400 font-semibold">Date actuelle</div>
            <div class="text-lg font-medium text-gray-900 mt-1">
                {{ formattedCurrentDate }}
            </div>
        </div>

        <!-- SELECTION MANUELLE -->
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
                Nouvelle date de licence
            </label>

            <div class="flex flex-col md:flex-row gap-4">
                <input
                    type="date"
                    v-model="newDateLicence"
                    class="border rounded-lg px-4 py-2 text-sm w-full md:w-auto"
                />

                <button
                    @click="changeDateLicence"
                    :disabled="loadingChangeDateLicence"
                    class="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg disabled:opacity-50 transition"
                >
                    <span v-if="!loadingChangeDateLicence">Mettre à jour</span>
                    <span v-else>Enregistrement...</span>
                </button>
            </div>
        </div>

        <!-- RACCOURCIS -->
        <div>
            <div class="text-sm font-medium text-gray-700 mb-3">
                Raccourcis rapides
            </div>

            <div class="flex flex-wrap gap-3">
                <button v-for="shortcut in shortcuts"
                        :key="shortcut.label"
                        @click="applyShortcut(shortcut.days)"
                        class="px-4 py-2 text-sm bg-slate-100 hover:bg-slate-200 rounded-lg transition">
                    {{ shortcut.label }}
                </button>
            </div>
        </div>

        <!-- ACTIONS CRITIQUES -->
        <div class="pt-6 border-t flex flex-wrap gap-4">

            <button
                @click="removeRestrictedAccess"
                class="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition"
            >
                Retirer accès restreint
            </button>

            <button
                @click="blockNow"
                class="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition"
            >
                Bloquer immédiatement
            </button>

        </div>

    </div>
</template>

<script>
export default {

    data() {
        return {
            newDateLicence: null,
            loadingChangeDateLicence: false,
            currentDate: null,

            shortcuts: [
                { label: "Dans 1 jour", days: 1 },
                { label: "Dans 2 jours", days: 2 },
                { label: "Dans 3 jours", days: 3 },
                { label: "1 semaine", days: 7 },
                { label: "2 semaines", days: 14 },
                { label: "3 semaines", days: 21 },
                { label: "1 mois", days: 30 }
            ]
        }
    },

    computed: {
        formattedCurrentDate() {
            if (!this.currentDate) return "Aucune date définie"
            return moment(this.currentDate).format('DD/MM/YYYY')
        }
    },

    mounted() {
        this.currentDate = this.$account.account.societe.date_licence || null
        this.newDateLicence = this.currentDate
            ? moment(this.currentDate).format('YYYY-MM-DD')
            : null
    },

    methods: {

        applyShortcut(days) {
            this.newDateLicence = moment().add(days, 'days').format('YYYY-MM-DD')
        },

        async changeDateLicence() {
            this.loadingChangeDateLicence = true

            await this.$request.post('/admin/societes/change-date-licence', {
                societe_id: this.$route.params.id,
                date: this.newDateLicence ? this.newDateLicence : 0
            })

            this.currentDate = this.newDateLicence
            this.$toast.success('Date de licence mise à jour')

            this.loadingChangeDateLicence = false
        },

        async removeRestrictedAccess() {
            this.newDateLicence = moment().add(10, 'years').format('YYYY-MM-DD')
            await this.changeDateLicence()
        },

        async blockNow() {
            this.newDateLicence = moment().format('YYYY-MM-DD')
            await this.changeDateLicence()
        }

    }
}
</script>
